<template>
  <div>
    <ShippingHeaderAdd @back="back" :title="id ? $t('atualizar-integracao') : $t('adicionar-nova-integracao')" />
    <ShippingIntegrationAddForm />
  </div>
</template>
<script>
import ShippingIntegrationAddForm from './ShippingIntegrationAddForm';
import ShippingHeaderAdd from "../components/ShippingHeaderAdd.vue";

export default {
  name: "ShippingAdd",
  components: {
    ShippingHeaderAdd,
    ShippingIntegrationAddForm,
  },
  data() {
    return {
      id: "",
    }
  },
  methods: {
    back() {
      this.$router.push({ name: "shipping" });
    },
    mounted() {
      const vm = this;
      if (this.$route.params.id) {
        this.id = this.$route.params.id;
      }
    },
  }
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

form {
  margin-top: 20px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}

.options {
  font-size: 16px;
}
</style>
